import { Tag } from 'antd';
import { Link } from 'react-router-dom';
import { formatDateTime } from 'utils/formatDate';

const STATUS_MAP = {
  1001: { label: 'Open', color: 'green' },
  1002: { label: 'Close', color: 'blue' },
};

export const columnsGenerator = params => [
  {
    title: '',
    dataIndex: 'id',
    align: 'center',
    render: id => <Link to={`/catalog/market-calendar/${id}`}>View</Link>,
  },
  {
    title: 'Date',
    dataIndex: 'date',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    render: value => {
      const status = STATUS_MAP[value] || { label: value, color: 'default' };
      return <Tag color={status.color}>{status.label}</Tag>;
    },
  },
  {
    title: 'Description',
    dataIndex: 'description',
  },
  {
    title: 'Created',
    dataIndex: 'created_at',
    render: value => formatDateTime(value),
  },
];
